import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";
import moment from "moment";
import InvoiceHeader from "./InvoiceHeader";

// Styles for the PDF document
const styles = StyleSheet.create({
  page: {
    padding: 15,
    border: "1px solid #333",
  },
  fontBold: { fontWeight: "bold" },
  header: {
    marginBottom: 10,
    textAlign: "right",
    borderBottom: "1px solid #333",
    paddingBottom: 5,
  },
  title: {
    fontSize: 15,
    fontWeight: "bold",
    marginBottom: 2,
  },
  subTitle: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 5,
  },
  section: {
    marginBottom: 10,
  },
  row: {
    flexDirection: "row",
  },
  bgText: {
    backgroundColor: "#000",
    marginBottom: 6,
    padding: 5,
    fontSize: 10,
    fontWeight: "bold",
    // width: "20",
    alignSelf: "flex-start",
    color: "#fff",
    display: "inline",
  },
  infoText: {
    fontSize: 10,
    marginBottom: 2,
    color: "#333",
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    width: "15%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    fontSize: 10,
  },
  tableCell: {
    fontSize: 8,
  },
  taxTable: {
    fontSize: 10,
    flex: 0.25,
    paddingVertical: 2,
    paddingHorizontal: 5,
    borderRight: "1px solid #000",
  },
  footer: {
    fontSize: 8,
    textAlign: "center",
    marginTop: 2,
  },
});

// Table Row Generator
const TableRow = ({ data, borderType = "" }) => (
  <View style={styles.tableRow}>
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "5%" }]}
    >
      <Text style={styles.tableCell}>{data?.sn || ""}</Text>
    </View>
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "15%" }]}
    >
      <Text style={styles.tableCell}>{data?.itemCd || ""}</Text>
    </View>
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "25%" }]}
    >
      <Text style={[styles.tableCell, { fontSize: 7 }]}>
        {data?.itemName || ""}
      </Text>
  
      <Text style={[styles.tableCell, { fontSize: 7 }]}>
        {data?.refund || ""}
      </Text>
    </View>
    <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.qty || ""}</Text>
    </View>
    <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.taxableAmt || ""}</Text>
    </View>{" "}
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "12%" }]}
    >
      <Text style={styles.tableCell}>{data?.taxAmt || ""}</Text>
    </View>{" "}
    <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.totalAmt || ""}</Text>
    </View>{" "}
  </View>
);
export const GeneratOrdertInvoice = ({
  record,
  currency,
  imageUrl,
  qrCodeBaseUrl,
  copy,
  header = "",
}) => {

  const qrCodeData = `${qrCodeBaseUrl}${record.sdcId}-${record.kra_order_id}`;
 
  const formatNumberByCommas = (number) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(number));
  };
  let la_taxes = [];
  const invoiceType = record.sale_receipt_type == "R" ? "Refund" : "Sales";

  // Product Data
  const productData = record.itemLists?.map((product, index) => {
    let lo_tax = {};
    let productPrice = 0.0;
    productPrice =
      product.qty > 0
        ? parseFloat(product.totAmt / product.qty)
        : parseFloat(product.totAmt);
    lo_tax["taxTyCd"] = product.taxTyCd;
    lo_tax["taxblAmt"] = parseFloat(product.taxblAmt);
    lo_tax["taxAmt"] = parseFloat(product.taxAmt);
    lo_tax["totAmt"] = parseFloat(product.totAmt);
    la_taxes = [...la_taxes, lo_tax];

    let refund_value = 0;

    if (record.sale_receipt_type == "R" && record?.refund_charge) {
      for (var k in record?.refund_charge) {
        if (k === product.itemSeq) {
          refund_value = record?.refund_charge[k];
        }
      }
    }
    // let item = record.cart.find((prod) => prod.item_code == product.itemCd);
    return {
      itemCd: product.itemCd,
      itemName: product.itemNm,
      discount:
        product.dcRt > 0
          ? `Discount -  ${Number(product.dcAmt).toFixed(2)} ${currency}`
          : `Discount -  0.00 ${currency}`,
      refund:
        refund_value > 0 &&
        `Refund Discount -  ${Number(refund_value).toFixed(2)} ${currency}`,
      qty: product.qty + "x" + `${Number(productPrice).toFixed(2)}`,
      rate: product?.taxTyCd && product?.tax_rate + "%",
      taxableAmt: formatNumberByCommas(product?.taxblAmt),
      taxAmt: formatNumberByCommas(product?.taxAmt),
      totalAmt: formatNumberByCommas(product.totAmt),
    };
  });

  // Rows per page
  const ROWS_PER_PAGE = 15;

  // Helper to split data into pages
  const paginateData = (data, rowsPerPage) => {
    const pages = [];
    for (let i = 0; i < data?.length; i += rowsPerPage) {
      pages.push(data.slice(i, i + rowsPerPage));
    }
    return pages;
  };


  const pages = paginateData(productData, ROWS_PER_PAGE);
  let totTaxAmt = parseFloat(0.0);
  let totTaxblAmt = parseFloat(0.0);
  let totAmt = parseFloat(0.0);
  const res_taxes = la_taxes.reduce((obj, item) => {
    let find = obj.find((i) => i.taxTyCd === item.taxTyCd);
    let _d = {
      ...item,
    };
    if (find) {
      find.taxblAmt += item.taxblAmt;
      find.taxAmt += item.taxAmt;
      find.totAmt += item.totAmt;
    } else {
      obj.push(_d);
    }
    totTaxAmt += parseFloat(item.taxAmt);
    totTaxblAmt += parseFloat(item.taxblAmt);
    totAmt += parseFloat(item.totAmt);
    return obj;
  }, []);

  const generalTaxIndex = res_taxes.findIndex(({ taxTyCd }) => taxTyCd == "B");
  const zeroRatedTaxIndex = res_taxes.findIndex(
    ({ taxTyCd }) => taxTyCd == "A"
  );
  const exemptedTaxIndex = res_taxes.findIndex(({ taxTyCd }) => taxTyCd == "C");

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.page}>
          <InvoiceHeader
            styles={styles}
            record={record}
            imageUrl={imageUrl}
            qrCodeData={qrCodeData}
            pageIndex={pageIndex}
            header={header}
          />

          {/* Product Table */}
          <View style={styles.table}>
            {/* Table Header */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "5%" }]}>
                <Text style={styles.tableCell}>SN</Text>
              </View>
              <View style={[styles.tableCol, { width: "15%" }]}>
                <Text style={styles.tableCell}>Item Code</Text>
              </View>
              <View style={[styles.tableCol, { width: "25%" }]}>
                <Text style={styles.tableCell}>Item Description</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Qty x Price</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Amt Excl. Tax</Text>
              </View>{" "}
              <View style={[styles.tableCol, { width: "12%" }]}>
                <Text style={styles.tableCell}>Tax Amt</Text>
              </View>{" "}
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Amt Incl. Tax</Text>
              </View>{" "}
            </View>

            {/* Product Rows */}
            {pageData.map((product, index) => (
              <TableRow
                key={index}
                data={{ ...product, sn: pageIndex * ROWS_PER_PAGE + index + 1 }}
              />
            ))}

            {/* Filler Rows */}
            {Array.from({ length: ROWS_PER_PAGE - pageData.length }).map(
              (_, fillerIndex) => (
                <TableRow key={`blank-${fillerIndex}`} borderType={0} />
              )
            )}
          </View>

          {pageIndex === pages.length - 1 && (
            <View style={[styles.row, { marginTop: 20 }]}>
              <View style={{ flex: 0.4, paddingRight: 40 }}>
                
                  <View>
                    <Text style={styles.infoText}>SCU INFORMATION</Text>
                    <Text>----------------------------</Text>
                    <Text style={styles.infoText}>
                      SCU ID: {`${record.sdcId}`}
                    </Text>
                    <Text style={styles.infoText}>
                      CU Invoice No.: {`${record.sdcId}/${record.kra_order_id}`}
                    </Text>
                    <Text style={styles.infoText}>
                      Int. Data: {`${record.intrlData}`}
                    </Text>
                    <Text style={styles.infoText}>
                      Rcpt Signature: {`${record.rcptSign}`}
                    </Text>
                  </View>
                
                <Text>----------------------------</Text>
                <View>
                  <Text style={styles.infoText}>
                    Date: {moment(record.created_date).format("DD-MM-YYYY")}
                  </Text>
                </View>
              </View>

              <View style={{ flex: 0.6 }}>
                <Text style={styles.title}>TAX SUMMARY</Text>
                <View style={styles.table}>
                  <View
                    style={[
                      styles.tableRow,
                      { borderBottom: "1px solid #000" },
                    ]}
                  >
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Tax Rate
                    </Text>
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Taxable Amt
                    </Text>
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Tax Amt
                    </Text>
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Total Amt
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.tableRow,
                      { borderBottom: "1px solid #000" },
                    ]}
                  >
                    <Text style={styles.taxTable}>16%</Text>
                    <Text style={styles.taxTable}>
                      {generalTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[generalTaxIndex]["taxblAmt"]
                          ).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {generalTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[generalTaxIndex]["taxAmt"]
                          ).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {generalTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[generalTaxIndex]["totAmt"]
                          ).toFixed(2)}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.tableRow,
                      { borderBottom: "1px solid #000" },
                    ]}
                  >
                    <Text style={styles.taxTable}>0%</Text>
                    <Text style={styles.taxTable}>
                      {" "}
                      {zeroRatedTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[zeroRatedTaxIndex]["taxblAmt"]
                          ).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {" "}
                      {zeroRatedTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[zeroRatedTaxIndex]["taxAmt"]
                          ).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {zeroRatedTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[zeroRatedTaxIndex]["totAmt"]
                          ).toFixed(2)}
                    </Text>
                  </View>{" "}
                  <View
                    style={[
                      styles.tableRow,
                      { borderBottom: "1px solid #000" },
                    ]}
                  >
                    <Text style={styles.taxTable}>Ex</Text>
                    <Text style={styles.taxTable}>
                      {exemptedTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[exemptedTaxIndex]["taxblAmt"]
                          ).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {exemptedTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[exemptedTaxIndex]["taxAmt"]
                          ).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {exemptedTaxIndex == -1
                        ? "0.00"
                        : parseFloat(
                            res_taxes[exemptedTaxIndex]["totAmt"]
                          ).toFixed(2)}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.tableRow,
                      { borderBottom: "1px solid #000" },
                    ]}
                  >
                    <Text style={styles.taxTable}>Total</Text>
                    <Text style={styles.taxTable}>
                      {parseFloat(totTaxblAmt).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {parseFloat(totTaxAmt).toFixed(2)}
                    </Text>
                    <Text style={styles.taxTable}>
                      {parseFloat(totAmt).toFixed(2)}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          )}

          {/* Footer */}
          <View
            style={{
              textAlign: "center",
              width: "100%",
              marginTop: 10,
              position: "absolute",
              bottom: 30,
              left: 0,
              right: 0,
            }}
          >
            <Image
              src={"/images/logo.jpg"}
              alt="Ocelot logo"
              style={{
                height: 35,
                objectFit: "contain",
                marginHorizontal: "auto",
              }}
            />
            <Text style={styles.footer}>
              This Sale Receipt was generated with the help of Ocelot Links POS.
            </Text>
            <Text style={styles.footer}>
              Learn more and create your own free trial account by visiting
              ocelotlinks.com or call 0711664444 for assistance.
            </Text>
            <Text style={[styles.footer, styles.fontBold]}>
              Powered by Ocelot Technologies Ltd
            </Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};
